import { createTranslationRef } from '@backstage/frontend-plugin-api';

export const catalogTranslationRef = createTranslationRef({
  id: 'catalog-devops',
  messages: {
    indexPage: {
      title: `{{orgName}} Catalog`,
    },
    overviewCard: {
      title: 'Overview',
      descriptionField: {
        label: 'Description',
        value: 'No description',
      },
      backstageOwnerField: {
        label: 'Backstage Owner',
        value: 'No Backstage Owner',
      },
      projectField: {
        label: 'Project',
        value: 'No Project',
      },
      accountField: {
        label: 'Account',
        value: 'No Account',
      },
      clusterField: {
        label: 'Cluster',
        value: 'No Cluster',
      },
      ruleSetField: {
        label: 'Rule Set',
        value: 'No Rule Set',
      },
      projectIdField: {
        label: 'Project ID',
        value: 'No Project ID',
      },
      accountIdField: {
        label: 'Account ID (Cloud)',
        value: 'No Account ID',
      },
      integrationIdField: {
        label: 'Integration ID',
        value: 'No Integration ID',
      },
      typeField: {
        label: 'Type',
        value: 'No Type',
      },
      regionField: {
        label: 'Region',
        value: 'No Region',
      },
      resultField: {
        label: 'Result',
        value: 'No Result',
      },
      severityField: {
        label: 'Severity',
        value: 'No Severity',
      },
      integrationOrganizationNameField: {
        label: 'Organization Name',
        value: 'No Organization Name',
      },
      repositoryField: {
        label: 'Repository RegEx',
        value: 'No Repository RegEx',
      },
      branchField: {
        label: 'Branch',
        value: 'No Branch',
      },
      catalogPathField: {
        label: 'Catalog Path',
        value: 'No Catalog Path',
      },
      updatedField: {
        label: 'Updated',
        value: 'No Updated',
      },
      statusField: {
        label: 'Status',
        value: 'No Status',
      },
      inventoryCreationTimeField: {
        label: 'Inventory Creation Time',
        value: 'No Time',
      },
      resourceUpdateTimeField: {
        label: 'Resource Update Time',
        value: 'No Time',
      },
      resourcesUpdateTimeField: {
        label: 'Resources Update Time',
        value: 'No Time',
      },
      reportCreationTimeField: {
        label: 'Report Creation Time',
        value: 'No Time',
      },
    },
    complianceCard: {
      title: 'Compliance',
      complianceField: {
        label: 'Compliance',
        value: 'No Compliance',
      },
      findingsField: {
        label: 'Findings',
        value: 'No Findings',
      },
    },
    regionPicker: {
      title: 'Region',
      errorMessage: 'Failed to load entity regions',
      optionAllTitle: 'all',
    },
    statusPicker: {
      title: 'Status',
      errorMessage: 'Failed to load rule status',
      optionAllTitle: 'all',
    },
    severityPicker: {
      title: 'Severity',
      errorMessage: 'Failed to load rule severities',
      optionAllTitle: 'all',
    },
    typePicker: {
      title: 'Type',
      errorMessage: 'Failed to load entity types',
      optionAllTitle: 'all',
    },
    catalogTable: {
      warningPanelTitle: 'Could not fetch catalog entities.',
      editActionTitle: 'Edit',
      deleteActionTitle: 'Delete',
    },
    searchResultItem: {
      Owner: 'Owner',
    },
    hasComponentsCard: {
      title: 'Has components',
      emptyMessage: 'No component is part of this system',
    },
    relatedEntitiesCard: {
      emptyHelpLinkTitle: 'Learn how to change this.',
    },
    entityLabels: {
      warningPanelTitle: 'Entity not found',
      ownerLabel: 'Owner',
      lifecycleLabel: 'Lifecycle',
    },
    entityContextMenu: {
      copiedMessage: 'Copied!',
      moreButtonTitle: 'More',
      inspectMenuTitle: 'Inspect entity',
      copyURLMenuTitle: 'Copy entity URL',
      unregisterMenuTitle: 'Unregister entity',
    },
  },
});
